/* src/app/components/profile/profile.component.scss */
.folha {
  max-width: min(640px, 100vw);
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  min-height: calc(100vh - 5rem);
  box-shadow: 6px 6px 12px #222;
}
.folha h1 {
  font-size: 2.5rem;
  padding-top: 2rem;
  text-align: center;
  width: 100%;
}
.pref-container {
  display: block;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 1em 3em;
}
.pref-container form {
  margin: auto;
  width: 100%;
}
.pref-container h2 {
  font-size: 1.5rem;
  text-align: left;
  padding-bottom: 0.3rem;
}
.pref-container h2:not(:first-child) {
  padding-top: 2.5rem;
}
.pref-container .input-com-ajuda {
  display: inline-block;
  width: 80%;
}
.ajuda {
  transform: scale(0.9);
  opacity: 0.6;
  vertical-align: middle;
  margin-left: 0.9rem;
}
@media (max-width: 700px) {
  .ajuda {
    transform: scale(0.75);
  }
}
.ajuda-container {
  display: inline-block;
  line-height: 2rem;
}
.ajuda-container .mat-icon {
  vertical-align: middle;
}
.imagem-usuario {
  width: 100%;
  text-align: center;
}
.imagem-usuario img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid #380415;
  filter: drop-shadow(0 0 8px #343a40);
}
.mat-input-wrapper {
  width: 18rem;
  padding-left: 1rem;
  line-height: 1rem;
  vertical-align: middle;
}
.action-buttons {
  line-height: 3rem;
  padding-top: 2rem;
  text-align: center;
  padding-bottom: 2rem;
  vertical-align: middle;
}
.action-buttons button {
  margin: 0 2rem;
}
.version-info {
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
  font-size: 0.75rem;
  text-align: center;
  line-height: 1rem;
}
.modal-content {
  background-color: #f7f7f7;
  border-radius: 2px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.modal-container {
  padding: 30px;
  max-width: 380px;
  width: 100% !important;
  margin: 0 auto;
  border-radius: 2px;
  overflow: hidden;
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
}
.modal-container h1 {
  text-align: center;
  font-size: 1.8rem;
}
.modal-container h2 {
  text-align: center;
  font-size: 1.5em;
}
.modal-container h3.traco {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}
.modal-container h3.traco span {
  background: #fff;
  padding: 0 10px;
}
.modal-container .form-field {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
@media (max-width: 300px) {
  .mat-input-wrapper {
    width: 15rem;
  }
  .action-buttons button {
    margin: 0 0.5rem;
  }
}
/*# sourceMappingURL=profile.component-H57GYQCF.css.map */
